import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AOS from 'aos';
import Header from './components/Header';
import Footer from './components/Footer';
import LoadingSpinner from './components/LoadingSpinner';
import ScrollToTop from './components/ScrollToTop';

// Lazy Load Pages
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const News = lazy(() => import('./pages/News'));
const NewsDetail = lazy(() => import('./pages/NewsDetail'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Lazy Load Sector Pages
const BTP = lazy(() => import('./pages/sectors/BTP'));
const Transport = lazy(() => import('./pages/sectors/Transport'));
const Immobilier = lazy(() => import('./pages/sectors/Immobilier'));
const Communication = lazy(() => import('./pages/sectors/Communication'));
const ImportExport = lazy(() => import('./pages/sectors/ImportExport'));
const Services = lazy(() => import('./pages/sectors/Services'));
const Security = lazy(() => import('./pages/sectors/Security'));
const SectorDetail = lazy(() => import('./pages/sectors/SectorDetail'));

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Header />
          <main>
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/actualites" element={<News />} />
                <Route path="/actualites/:slug" element={<NewsDetail />} />

                {/* Routes secteurs */}
                <Route path="/secteurs/btp" element={<BTP />} />
                <Route path="/secteurs/transport" element={<Transport />} />
                <Route path="/secteurs/immobilier" element={<Immobilier />} />
                <Route path="/secteurs/communication" element={<Communication />} />
                <Route path="/secteurs/import-export" element={<ImportExport />} />
                <Route path="/secteurs/import_export" element={<ImportExport />} />
                <Route path="/secteurs/services" element={<Services />} />
                <Route path="/secteurs/security" element={<Security />} />
                <Route path="/secteurs/securite" element={<Security />} />
                <Route path="/secteurs/:slug" element={<SectorDetail />} />

                {/* 404 */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
